"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Card_1 = __importDefault(require("@mui/material/Card"));
var CardActions_1 = __importDefault(require("@mui/material/CardActions"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
var CardMedia_1 = __importDefault(require("@mui/material/CardMedia"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Integrations_module_css_1 = __importDefault(require("../Integrations.module.css"));
var react_i18next_1 = require("react-i18next");
var IntegrationSelectMenuItem = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement(Card_1.default, { sx: { width: 344, boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" } },
        react_1.default.createElement(CardMedia_1.default, { component: "img", alt: props.integrationType.name, height: "140", image: props.integrationType.imageUrl }),
        react_1.default.createElement(CardContent_1.default, null,
            react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "div", style: { color: "var(--info-color)" } },
                react_1.default.createElement("span", { className: "ns-font-family-bold" }, props.integrationType.name)),
            react_1.default.createElement(Typography_1.default, { variant: "body2" },
                react_1.default.createElement("span", { className: "ns-font-family" }, t(props.integrationType.description)))),
        react_1.default.createElement(CardActions_1.default, null,
            react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "secondary", dataCy: "integrationTypeSelectButton", onClick: props.onSelect }, t("Select")))));
};
var IntegrationSelectMenu = function (props) {
    return (react_1.default.createElement("div", { className: Integrations_module_css_1.default.integration_card_container }, props.integrationTypes.map(function (integrationType) {
        return react_1.default.createElement("div", { key: integrationType.name, className: Integrations_module_css_1.default.integration_card_wrapper },
            react_1.default.createElement(IntegrationSelectMenuItem, { integrationType: integrationType, onSelect: function () { return props.selectIntegrationType(integrationType); } }));
    })));
};
exports.default = IntegrationSelectMenu;
